import styled from 'styled-components'

import { theme } from '../../theme'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  padding: 5% 5% 60px 5%;

  @media (min-width: ${theme.breakpoints.sm}px) {
    width: 70%;
    padding: 30px 5%;
  }
`

export const Title = styled.h1`
  font-size: 22px;
  line-height: 32px;
  font-weight: 600;
`

export const Description = styled.p`
  font-weight: 500;

  font-size: 18px;
  line-height: 28px;
`

export const Wrapper = styled.div`
  padding-top: 40px;
  max-width: 600px;
`
